import { AxiosInstance } from 'axios';
import OriginVhostRepositoryInterface, {
  OriginVhostConfigUpdateInterface,
  OriginVhostCreateInterface,
  OriginVhostInterface,
  OriginVhostPHPConfigParameterInterface,
  OriginVhostPHPModuleInterface,
  OriginVhostUpdateInterface,
} from 'src/services/Vhost/Origin/Interfaces';

export default class OriginVhostRepository implements OriginVhostRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async searchVhosts(page?: number, search?: string): Promise<[OriginVhostInterface[], number]> {
    let url = `/origin-vhost/vhosts?page=${page}`;
    if (search) {
      url = `${url}&search=${search}`;
    }

    const response = await this.axios.get(url);

    return response.data;
  }

  public async createVhost(data: OriginVhostCreateInterface): Promise<void> {
    await this.axios.post('/origin-vhost/vhosts', data);
  }

  public async getPHPModules(): Promise<OriginVhostPHPModuleInterface[]> {
    const response = await this.axios.get('/origin-vhost/php/modules');

    return response.data;
  }

  public async getPHPConfigParameters(): Promise<OriginVhostPHPConfigParameterInterface[]> {
    const response = await this.axios.get('/origin-vhost/php/config-parameters');

    return response.data;
  }

  public async updateVhost(id: number, data: OriginVhostUpdateInterface): Promise<void> {
    await this.axios.patch(`/origin-vhost/vhosts/${id}`, data);
  }

  public async createPHPModule(name: string): Promise<OriginVhostPHPModuleInterface> {
    const response = await this.axios.post('/origin-vhost/php/modules', { name });

    return response.data;
  }

  public async deleteVhost(id: number): Promise<void> {
    await this.axios.delete(`/origin-vhost/vhosts/${id}`);
  }

  public async updatePHPConfig(id: number, config: OriginVhostConfigUpdateInterface): Promise<void> {
    await this.axios.patch(`/origin-vhost/vhosts/${id}/php`, config);
  }

  public async deleteLog(id: number): Promise<void> {
    await this.axios.delete(`/origin-vhost/logs/${id}`);
  }

  public async getVhostByWebsiteId(websiteId: number): Promise<OriginVhostInterface> {
    const response = await this.axios.get(`/origin-vhost/vhosts/websites/${websiteId}`);

    return response.data;
  }

  public async createWildCard(id: number): Promise<void> {
    await this.axios.patch(`/origin-vhost/vhosts/${id}/wildcard`)
  }

  public async removeWildCard(id: number): Promise<void> {
    await this.axios.patch(`/origin-vhost/vhosts/${id}/wildcard?remove=true`)
  }
}
